const PresetsPopoverItem = ({ imgUrl, onClick }) => (
  <div onClick={onClick} className="velorbis-customizer-gallery-popover-item">
    <div className="velorbis-customizer-gallery-popover-item-img">
      <img src={imgUrl} alt="preset" />
    </div>
  </div>
)

export default PresetsPopoverItem
